import { Grid } from '@material-ui/core';
import AutoCarousel from 'components/AutoCarousel';
import messages from 'containers/AutoDetailsPage/CompensationServices/messages';
import {
  BlocTitle,
  BodyTitle,
  ButtonItem,
  FullHighedGrid,
  ItemsWrapper,
  SizedCaptions,
  StyledCaptions,
  StyledGrid,
  Wrapper,
} from 'containers/AutoDetailsPage/CompensationServices/styles';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images/index';
import { truncate } from 'lodash';
import { sanlamBlue } from 'Material-UI/colors';
import React from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import PAGES from 'routes/pages';
import { breadcrumbsItemType } from 'store/global/types';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
const CompensationServices = ({
  setBreadcrumbsPath,
  rootPath,
  ...props
}: {
  intl: IntlShape;
  setBreadcrumbsPath: Function;
  rootPath: breadcrumbsItemType[];
}) => {
  const lang = useSelector(getLocaleSelector);
  const isArabic = lang === LANGUAGES.AR;
  const items = [
    {
      title: translate(messages.SlideOneTitle, props),
      subTitle: translate(messages.SlideOneSubTitle, props),
      bodyContent: truncate(translate(messages.SlideOneBodyContent, props), {
        length: isArabic ? 79 : 118,
      }),
      icon: 'Bitmap',
      category: EVENT_CATEGORIES.AUTO_DETAILS,
      label: "Mes services d'indémnisation_CAE_En savoir plus",
    },
    {
      title: translate(messages.SlideTwoTitle, props),
      bodyContent: truncate(translate(messages.SlideTwoBodyContent, props), {
        length: isArabic ? 78 : 136,
      }),
      icon: 'Bitmap',
      category: EVENT_CATEGORIES.AUTO_DETAILS,
      label: "Mes services d'indémnisation_Alerte mobile_En savoir plus",
    },
    {
      title: translate(messages.SlideThreeTitle, props),
      bodyContent: truncate(translate(messages.SlideThreeBodyContent, props), {
        length: isArabic ? 79 : 136,
      }),
      icon: 'Bitmap',
      category: EVENT_CATEGORIES.AUTO_DETAILS,
      label: "Mes services d'indémnisation_EAD_En savoir plus",
    },
  ];
  const Chevron = isArabic ? ChevronLeft : ChevronRight;
  return (
    <Wrapper>
      <BlocTitle>
        {translate(messages.MyCompensationServices, props)}{' '}
      </BlocTitle>
      <AutoCarousel>
        {items.map((item, index) => {
          return (
            <ItemsWrapper key={index} isArabic={isArabic}>
              <FullHighedGrid justify="space-evenly" container>
                <Grid item xs={4}>
                  <img
                    height="99"
                    alt="bitcamp-icon"
                    width="99"
                    src={AssuranceIcon[item.icon]}
                  />
                </Grid>
                <Grid item xs={7}>
                  <FullHighedGrid
                    container
                    justify="space-between"
                    direction="column"
                  >
                    <StyledGrid item xs>
                      <BodyTitle weight="bold">{item.title}</BodyTitle>
                    </StyledGrid>
                    {item.subTitle && (
                      <StyledGrid item xs>
                        <StyledCaptions
                          lineHeight="18px"
                          isMarginBottom
                          weight="500"
                        >
                          {item.subTitle}
                        </StyledCaptions>
                      </StyledGrid>
                    )}
                    <StyledGrid item xs>
                      <SizedCaptions weight="400">
                        {item.bodyContent}
                      </SizedCaptions>
                    </StyledGrid>
                    <StyledGrid item xs>
                      <GaClickHOC label={item.label} category={item.category}>
                        <ButtonItem
                          onClick={() => {
                            if (setBreadcrumbsPath) {
                              setBreadcrumbsPath([
                                ...rootPath,
                                {
                                  name: 'autoServices',
                                  route: PAGES.CompensationServicesPage,
                                },
                              ]);
                            }
                          }}
                          data-testid={`find-out-more-${index}`}
                        >
                          <StyledCaptions lineHeight="14px" color={sanlamBlue}>
                            {translate(messages.FindOutMOre, props)}
                          </StyledCaptions>
                          <Chevron
                            width="16px"
                            height="16px"
                            color={sanlamBlue}
                          />
                        </ButtonItem>
                      </GaClickHOC>
                    </StyledGrid>
                  </FullHighedGrid>
                </Grid>
              </FullHighedGrid>
            </ItemsWrapper>
          );
        })}
      </AutoCarousel>
    </Wrapper>
  );
};

export default injectIntl(CompensationServices);
